import { useTranslation } from "react-i18next";

/**
 * Returns the localized field value based on current language.
 * Usage: const name = useLocalized(venue, "name") 
 * When lang=el returns venue.name_el || venue.name
 * When lang=en returns venue.name
 */
export function useLocalized(obj, field) {
  const { i18n } = useTranslation();
  if (!obj) return "";
  if (i18n.language === "el") {
    return obj[`${field}_el`] || obj[field] || "";
  }
  return obj[field] || "";
}

/**
 * Non-hook version for use in map/filter callbacks
 */
export function getLocalized(obj, field, lang) {
  if (!obj) return "";
  if (lang === "el") {
    return obj[`${field}_el`] || obj[field] || "";
  }
  return obj[field] || "";
}
